import React from 'react';
import './DocumentUploadInput.css';

const DEFAULT_ACCEPT = '.pdf,application/pdf,image/jpeg,image/png,image/webp,image/gif';

const DocumentUploadInput = ({
  title,
  description = 'Sin archivo cargado',
  inputLabel,
  accept = DEFAULT_ACCEPT,
  buttonLabel = 'Subir archivo',
  busyLabel = 'Subiendo…',
  busy = false,
  disabled = false,
  fullWidth = false,
  hasFile = false,
  showUploadButton = true,
  helperText,
  actions,
  onFileSelected
}) => {
  const handleChange = (event) => {
    const selectedFile = event.currentTarget.files?.[0];
    event.currentTarget.value = '';
    if (selectedFile) onFileSelected?.(selectedFile);
  };

  const fieldClassName = `document-upload-field${fullWidth ? ' document-upload-field--full-width' : ''}`;
  const isDisabled = disabled || busy;
  const buttonClassName = [
    'service-document-upload-button',
    busy && 'service-document-upload-button--busy',
    isDisabled && 'service-document-upload-button--disabled'
  ].filter(Boolean).join(' ');

  return (
    <div className={fieldClassName}>
      <div className={`service-document-tile${hasFile ? '' : ' service-document-tile--empty'}`}>
        <div className="service-document-thumbnail-wrap">
          <span
            className={`service-document-thumbnail ${hasFile ? 'service-document-thumbnail--uploaded' : 'service-document-thumbnail--empty'}`}
            aria-hidden="true"
          >
            {hasFile ? (
              <svg viewBox="0 0 24 24" className="service-document-file-icon">
                <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
                <path d="M13 2v7h7M8 14h8M8 18h8" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" className="service-document-missing-icon">
                <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
                <path d="M13 2v7h7M8 13h3M8 17h5M3 3l18 18" />
              </svg>
            )}
          </span>
        </div>
        <div className="service-document-copy">
          <strong>{title}</strong>
          <span title={description}>{description}</span>
        </div>
        {actions}
        {showUploadButton && (
          <label className={buttonClassName}>
            <input
              className="service-document-file-input"
              type="file"
              accept={accept}
              disabled={isDisabled}
              aria-label={inputLabel || `Subir ${String(title || 'documento').toLowerCase()}`}
              onChange={handleChange}
            />
            {busy ? busyLabel : buttonLabel}
          </label>
        )}
      </div>
      {helperText && <small className="service-document-upload-hint">{helperText}</small>}
    </div>
  );
};

export default DocumentUploadInput;
